import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentType } from '@angular/cdk/portal';
import { InjectionToken } from '@angular/core';

export interface ModalActionButton {
  style: 'primary' | 'secondary' | 'tertiary' | 'default';
  onClick: any;
  text: string;
  data?: Object;
  disabled?: boolean;
}

export interface ModalData<T> {
  actions: ModalActionButton[];
  template: ComponentType<T>;
  templateData: any;
  spinnerText?: string;
  modalHeight?: string;
}

export const MODAL_TEMPLATE_DATA = new InjectionToken<ModalData<any>>('MODAL_TEMPLATE_DATA');

export class ModalRef {
  constructor(private readonly overlay: OverlayRef) { }

  close() {
    this.overlay.dispose();
  }
}
